export enum SpecialTrackOptionsEnum {
  PrimaryCare = 'Primary Care',
  Rural = 'Rural',
  WomensHealth = 'Womens \'s Health',
  Hospitalist = 'Hospitalist',
  ResearchTrackFellowship = 'Research track/fellowship (non-ACGME accredited)',
  Educator = 'Academic or clinician educator',
}
